import app from "/src/app/app.module";

app.controller('contactFormDetailsCtrl',
    function ($scope, vxUtils, $contactForms, $filter, toastr, tabService, vxSession, msgBus, msgBusActions, sweet, $locale) {

        var tab = tabService.getCurrentTab();
        var id = tab.id;

        $scope.locale = $locale;
        $scope.submission = {};
        $scope.matchedCustomer = null;
        $scope.customerLookupDone = false;
        $scope.actionBarCpi = {};
        $scope.PageHash = vxUtils.generateQuickGuid();

        $scope.auth = function () {
            return parseInt(vxSession.userRole) > 1;
        };

        $scope.init = function (submissionId) {
            $contactForms.getById(submissionId, function (result) {
                $scope.submission = result;
                tab.tabname = $filter('translate')('CONTACT_FORM') + ' #' + result.id;
                
                // Update action bar state based on processed status
                $scope.updateActionBarState();
                
                // Lookup existing customer by email or phone
                $scope.lookupCustomer(result.email, result.phone);
            }, function (error) {
                toastr.error($filter('translate')('ERROR_LOADING'), $filter('translate')('ERROR'));
            });
        };

        $scope.updateActionBarState = function () {
            // Show/hide buttons based on processed status
            $scope.actionitems[0].hidden = $scope.submission.isProcessed;  // Mark as Processed button
            $scope.actionitems[4].hidden = !$scope.submission.isProcessed; // Undo Processed button
        };

        $scope.lookupCustomer = function (email, phone) {
            $contactForms.lookupCustomer(email, phone, function (result) {
                $scope.matchedCustomer = result;
                $scope.customerLookupDone = true;
            }, function (error) {
                $scope.matchedCustomer = null;
                $scope.customerLookupDone = true;
            });
        };

        $scope.openCustomer = function () {
            if ($scope.matchedCustomer && $scope.matchedCustomer.idClient) {
                msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                    type: 'customer',
                    id: $scope.matchedCustomer.idClient
                });
            }
        };

        $scope.createCustomer = function () {
            msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                type: 'create',
                id: 'customer',
                tab: {
                    prefill: {
                        name: $scope.submission.name,
                        email: $scope.submission.email,
                        phone: $scope.submission.phone
                    }
                }
            });
        };

        $scope.createJob = function () {
            if (!$scope.matchedCustomer) {
                toastr.warning($filter('translate')('NO_EXISTING_CUSTOMER_FOUND'), $filter('translate')('ERROR'));
                return;
            }
            
            // Prefill job wizard with quote request data
            msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                type: 'create',
                id: 'job',
                tab: {
                    prefill: {
                        customer: $scope.matchedCustomer,
                        jobData: {
                            guests: $scope.submission.expectedGuests,
                            remarks: $scope.submission.additionalNotes,
                            kindofparty: $scope.submission.eventType
                        },
                        location: {
                            name: $scope.submission.eventLocation
                        },
                        eventDate: $scope.submission.eventDate,
                        quoteType: $scope.submission.quoteType,
                        referralSource: $scope.submission.referralSource
                    }
                }
            });
        };

        $scope.markAsProcessed = function () {
            $contactForms.markProcessed($scope.submission.id, function (result) {
                $scope.submission.isProcessed = true;
                $scope.updateActionBarState();
                toastr.success($filter('translate')('MARKED_AS_PROCESSED'), $filter('translate')('SUCCES'));
                msgBus.emitMsg(msgBusActions.overviewReload, 'contact-form');
            }, function (error) {
                toastr.error($filter('translate')('ERROR_PROCESSING'), $filter('translate')('ERROR'));
            });
        };

        $scope.markAsUnprocessed = function () {
            $contactForms.markUnprocessed($scope.submission.id, function (result) {
                $scope.submission.isProcessed = false;
                $scope.updateActionBarState();
                toastr.success($filter('translate')('MARKED_AS_UNPROCESSED'), $filter('translate')('SUCCES'));
                msgBus.emitMsg(msgBusActions.overviewReload, 'contact-form');
            }, function (error) {
                toastr.error($filter('translate')('ERROR_PROCESSING'), $filter('translate')('ERROR'));
            });
        };


        // Action bar items
        $scope.actionitems = [
            {
                href: "",
                label: vxUtils.loc('MARK_AS_PROCESSED'),
                click: function () {
                    sweet.show({
                        title: vxUtils.loc('MARK_AS_PROCESSED'),
                        text: vxUtils.loc('CONFIRM_MARK_AS_PROCESSED'),
                        type: 'success',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: vxUtils.loc('YES'),
                        closeOnConfirm: true
                    }, function () {
                        $scope.markAsProcessed();
                    });

                },
                icon: "fa fa-check fa-2x green",
                hidden: false
            },
            {
                label: vxUtils.loc('SEND_EMAIL'),
                href: "/src/panel/mail-dialog.html",
                icon: "fa fa-envelope fa-2x"
            },
            {
                label: vxUtils.loc('DELETE'),
                href: "/src/panel/delete-dialog.html",
                icon: "fa fa-trash-o fa-2x"
            },
            {
                label: vxUtils.loc('REFRESH'),
                click: function () {
                    $scope.init(id);
                    toastr.info($filter('translate')('REFRESHING'), $filter('translate')('BUSY'));
                },
                href: "",
                icon: "fa fa-refresh fa-2x"
            },
            {
                label: vxUtils.loc('UNDO_PROCESSED'),
                href: "",
                click: function () {
                    if (confirm($filter('translate')('CONFIRM_UNDO_PROCESSED'))) {
                        $scope.markAsUnprocessed();
                    }
                },
                icon: "fa fa-undo fa-2x orange",
                hidden: true
            }
        ];

        $scope.actionBarCpi.pageHash = $scope.PageHash;
        $scope.actionBarCpi.mailobject = {
            get email() { return $scope.submission.email; },
            get name() { return $scope.submission.name; }
        };
        $scope.actionBarCpi.submission = function () { return $scope.submission; };
        // Only allow email action in mail dialog for contact forms
        $scope.actionBarCpi.allowedActions = ['email'];

        $scope.scrollMethod = function ($event, $delta, $deltaX, $deltaY) {
            vxUtils.scrollHorzontal($event, $delta, $deltaX, $deltaY, $scope.PageHash);
        };

        $scope.init(id);
    });
